export class Logger {
	private static _currentLogLevel: number = 0;
	private static _environment: string;

	public static init(env: string, logLevel: number): void {
		this._environment = env;
		this._currentLogLevel = logLevel;
	}

	public static log(level: number, msg: string) {
		if (this._environment === "dev") {
			if (level <= this._currentLogLevel) {
				let logNow: Date = new Date();

				console.log(logNow.toDateString() + " | " + level + " | " + msg);
			}
		}
	}

	public static set currentLogLevel(level: number) {
		this._currentLogLevel = level;
	}

	public static get currentLogLevel() {
		return this._currentLogLevel;
	}
}
